import Vue from "vue";
import Router from "vue-router";
import Index from "@/pages/index";

Vue.use(Router);

export default new Router({
  mode: "history",
  srcollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  },
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    // 产品&解决方案
    {
      path: "/solution",
      name: "Solution",
      component: () => import("@/pages/solution/solution")
    },
    {
      path: "/product",
      name: "Product",
      component: () => import("@/pages/solution/product")
    },
    // 客户案例
    {
      path: "/case",
      name: "CustomerCase",
      component: () => import("@/pages/customerCase/index")
    },
    // 核心技术
    {
      path: "/technology",
      name: "Technology",
      component: () => import("@/pages/technology/index")
    },
    // 新闻动态
    {
      path: "/news",
      name: "News",
      component: () => import("@/pages/news/index")
    },
    // 新闻动态详情
    {
      path: "/detail",
      name: "NewsDetail",
      component: () => import("@/pages/news/detail")
    },
    // 新闻动态详情
    {
      path: "/party",
      name: "PartyBuilding",
      component: () => import("@/pages/party/index")
    },
    // 关于我们
    {
      path: "/about",
      name: "About",
      component: () => import("@/pages/about/index")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js